import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { FlatRate } from "@/components/FlatRate";
import { Gallery } from "@/components/Gallery";
import { Services } from "@/components/Services";
import { QuoteForm } from "@/components/QuoteForm";
import { Footer } from "@/components/Footer";
import { MobileCTA } from "@/components/MobileCTA";

export default function Home() {
  return (
    <div className="relative bg-ice">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <FlatRate />
        <Gallery />
        <Services />
        <QuoteForm />
      </main>
      <Footer />
      <MobileCTA />
    </div>
  );
}
